import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

const SECURITY_ATTACK_PATHS_OVERVIEW_QUERY_KEY =
  'security-attack-paths-overview';

const getAttackPathsOverviewQueryOptions = () =>
  queryOptions({
    queryKey: [SECURITY_ATTACK_PATHS_OVERVIEW_QUERY_KEY],
    queryFn: async () => {
      const { data } =
        await apiClient.securityInsights.getAttackPathsOverview();
      return data;
    },
  });

export const useAttackPathsOverviewQuery = () => {
  const {
    isLoading,
    data: overview,
    error,
    refetch,
  } = useQuery(getAttackPathsOverviewQueryOptions());

  return { isLoading, overview, error, refetch };
};
